import { SHIPPING_TRACKING, RESPONSE_STATUS, CLEAR_RESPONSE } from './commonTypes'
export default (state, action) => {
    switch (action.type) {
        case SHIPPING_TRACKING:
            return {
                ...state,
                shipping_tracking: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
